import {
  DialogDisclosure,
  useDialogStore,
  useStoreState,
} from "@ariakit/react";
import { AccountIcon } from "@indietabletop/appkit";
import { type ReactNode } from "react";
import { Link } from "wouter";
import { navLinks } from "../DashboardPage/navLinks.ts";
import gitburger from "../Page/gitburger.svg";
import accountIcon from "./account.webp";
import { Sidenav } from "./Sidenav.tsx";
import { SidenavContext, useSidenavStore } from "./SidenavContext.tsx";
import spaceGitsLogo from "./spacegits_spine_logo.png";
import { account, layout, menu, navLink, spine } from "./style.css.ts";

function AccountButton() {
  return (
    <Link href="~/settings" className={account.menuButton}>
      <AccountIcon imgSrc={accountIcon} />
    </Link>
  );
}

export function NavLink(
  props: Pick<
    (typeof navLinks)[number],
    "heading" | "description" | "disabled" | "href"
  >,
) {
  const { heading, description, href, disabled } = props;

  return (
    <Link href={href} className={navLink.container({ disabled })}>
      <div className={navLink.heading}>{heading}</div>
      <div className={navLink.description}>{description}</div>

      {disabled && <div className={navLink.disabled}>Under construction</div>}
    </Link>
  );
}

function Spine() {
  const store = useSidenavStore();
  const isOpen = useStoreState(store, (c) => c.open);

  return (
    <div className={spine.container({ withDropShadow: !isOpen })}>
      <DialogDisclosure className={menu.button} store={store}>
        <img src={gitburger} alt="" />
        <div className={menu.label}>Menu</div>
      </DialogDisclosure>

      <div className={spine.title}>
        <Link href="~/" style={{ display: "contents" }}>
          <img src={spaceGitsLogo} alt="Space Gits" className={spine.logo} />
        </Link>
      </div>

      <AccountButton />
    </div>
  );
}

/**
 * Layout component used in most of the app.
 *
 * Important: Only a single in-flow DOM element should be passed as child.
 */
export function Layout(props: { children: ReactNode }) {
  const store = useDialogStore();

  return (
    <SidenavContext value={store}>
      <div className={layout.container}>
        <Spine />
        <Sidenav />

        {props.children}
      </div>
    </SidenavContext>
  );
}
